import { BlockStack, Grid, Text, Button, ButtonGroup, ContextualSaveBar, InlineStack } from '@shopify/polaris';
import { Switch } from 'antd';
// import {Grid } from 'antd';
import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { DI, DIProps } from '../../../../../Core';
import useContextualSaveBar, { isAdminLoggedIn } from '../../../Panel/index';

interface sandboxDataI {
    shipment_setting_enabled: boolean;
    order_setting_enabled: boolean;
}

const SandboxApi = (props: DIProps) => {

    const { showSaveBar, hideSaveBar } = useContextualSaveBar(props);

    const [sandboxData, setSandboxData] = useState<sandboxDataI>({
        shipment_setting_enabled: false,
        order_setting_enabled: false
    })
    const [initsandboxData, setinitSandboxData] = useState<sandboxDataI>({
        shipment_setting_enabled: false,
        order_setting_enabled: false
    })
    const [loader, setLoader] = useState(false);
    const [saveLoader, setSaveLoader] = useState(false);

    const handleChange = (key: keyof sandboxDataI, value: boolean) => {
        setSandboxData(a => ({ ...a, [key]: value }))
    }

    const getConfig = () => {
        setLoader(true);
        props.di.POST('connector/config/getConfig', {
            "group_code": ["sandbox"]
        }).then((data) => {
            setLoader(false)
            if (data.success && data?.data?.[0]?.group_code === 'sandbox') {
                setSandboxData({
                    shipment_setting_enabled: !!data?.data?.[0]?.value?.shipment_setting_enabled,
                    order_setting_enabled: !!data?.data?.[0]?.value?.order_setting_enabled
                });
                setinitSandboxData({
                    shipment_setting_enabled: !!data?.data?.[0]?.value?.shipment_setting_enabled,
                    order_setting_enabled: !!data?.data?.[0]?.value?.order_setting_enabled
                })
            }
        })
    }

    function onSaveAction() {
        setSaveLoader(true);
        props.di.POST('connector/config/saveConfig', {
            "data": [
                {
                    "data": {
                        ...sandboxData
                    },
                    "group_code": "sandbox"
                }
            ]
        }).then((data) => {
            setSaveLoader(false);
            if (data.success) {
                getConfig();
                props.success(data.message)
            } else {
                props.error(data.message)
            }
        })
    }

    useEffect(() => {
        getConfig()
    }, [])

    const showContextualSaveBar = () => {
        if (initsandboxData.shipment_setting_enabled !== sandboxData.shipment_setting_enabled)
            return true;
        if (initsandboxData.order_setting_enabled !== sandboxData.order_setting_enabled)
            return true;
        return false;
    };

    //Contextual Save Bar of App Bridge
    if (process.env.REACT_APP_PROD === "1" && !isAdminLoggedIn()) {
        if (showContextualSaveBar()) {
            showSaveBar(() => { }, onSaveAction, {});
        } else hideSaveBar();
    }

    return <>

        {showContextualSaveBar() && (process.env.REACT_APP_PROD === "0" ||
            isAdminLoggedIn()) && (
                <ContextualSaveBar
                    message="Unsaved changes"
                    saveAction={{
                        onAction: () => { onSaveAction() },
                        loading: saveLoader || loader,
                    }}
                    discardAction={{
                        onAction: () => { },
                        disabled: saveLoader || loader,
                    }}
                />
            )}
        <BlockStack gap="500">

            <Grid columns={{ xs: 1, sm: 1, md: 3, lg: 3, xl: 3 }} >
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }} >
                    <InlineStack gap='400' blockAlign='start'>
                        <Switch
                            className='switcherBtn'
                            size='small'
                            id='send_mail_on_limit_exceed'
                            checked={sandboxData.shipment_setting_enabled}
                            disabled={loader || saveLoader}
                            onChange={(checked) => { handleChange('shipment_setting_enabled', checked) }}
                        />
                        <BlockStack gap="200">
                            <Text variant="headingMd" as="h6" >
                                Shipment Sandbox API's
                            </ Text>
                            <Text as="p" fontWeight="regular" tone='subdued' >
                                Enable Shipment Sandbox api's
                            </Text>
                        </BlockStack>
                    </InlineStack>
                    <InlineStack gap='400' blockAlign='start'>
                        <Switch
                            className='switcherBtn'
                            size='small'
                            id='send_mail_on_limit_exceed'
                            disabled={loader || saveLoader}
                            checked={sandboxData.order_setting_enabled}
                            onChange={(checked) => { handleChange('order_setting_enabled', checked) }}
                        />
                        <BlockStack gap="200">
                            <Text variant="headingMd" as="h6" >
                                Order Sandbox API's
                            </ Text>
                            <Text as="p" fontWeight="regular" tone='subdued' >
                                Enable Order Sandbox api's
                            </Text>
                        </BlockStack>
                    </InlineStack>
                </Grid.Cell>
                <Grid.Cell columnSpan={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}>
                    <div className='Custom__Button--Alignment'>
                        {/* <ButtonGroup variant="segmented">
                            <Button pressed={sandboxData.shipment_setting_enabled} onClick={() => { handleChange(true) }}>
                                Enable
                            </Button>
                            <Button pressed={!sandboxData.shipment_setting_enabled} onClick={() => { handleChange(false) }}>
                                Disable
                            </Button>
                        </ButtonGroup> */}
                    </div>
                </Grid.Cell>
            </Grid>

        </BlockStack>
    </>;

}


export default DI(SandboxApi);